import React from 'react'
import TriggerNodeTemplate from '../templates/TriggerNodeTemplate'
import { Tooltip, Typography } from '@mui/material'

export default function AbandonedCart({ id, type, data, selected }) {
    return (
        <TriggerNodeTemplate id={id} type={type} data={data} selected={selected}>
            <Tooltip>
                <Typography fontSize={8} noWrap>
                    Cart abandoned
                </Typography>
            </Tooltip>
        </TriggerNodeTemplate>
    )
}
